/**
 * Origem Flow: kudos (reconhecimento) e anel do dia — /api/kudos/*.
 */
export default (client) => {
  return {
    feed(workspaceId) {
      return client.get(`/kudos/workspace/${workspaceId}/`)
    },
    give(workspaceId, values) {
      return client.post(`/kudos/workspace/${workspaceId}/`, values)
    },
    forRow(tableId, rowId) {
      return client.get(`/kudos/table/${tableId}/row/${rowId}/`)
    },
    ring(workspaceId) {
      return client.get(`/kudos/workspace/${workspaceId}/ring/`)
    },
  }
}
